export default "__VITE_ASSET__d6d937c6__"